import { Course } from '../../types';
import { llmFoundationsModule1 } from '../modules/llmFoundationsModule1';
import { llmFoundationsModule2 } from '../modules/llmFoundationsModule2';
import { llmFoundationsModule3 } from '../modules/llmFoundationsModule3';
import { llmFoundationsModule4 } from '../modules/llmFoundationsModule4';
import { llmFoundationsModule5 } from '../modules/llmFoundationsModule5';
import { llmFoundationsModule6 } from '../modules/llmFoundationsModule6';

export const llmFoundationsCourse: Course = {
  id: 'llm-foundations',
  title: 'LLM Foundations: Complete Course',
  description:
    'A comprehensive 6-module course on Large Language Models with a layered learning approach. Start with conceptual foundations and progressively dive deeper into architecture, mathematics, implementation, advanced techniques, and research frontiers.',
  category: 'ai-fundamentals',
  difficulty: 'beginner',
  estimatedHours: 60,
  prerequisites: ['basic-programming', 'basic-mathematics'],
  tags: [
    'llm',
    'language-models',
    'ai',
    'machine-learning',
    'transformers',
    'deep-learning',
    'nlp',
    'foundations',
    'ethics',
    'business-impact',
    'tokenization',
    'attention-mechanisms',
    'context-windows',
    'text-generation',
    'architecture',
    'mathematics',
    'implementation',
    'research',
  ],
  thumbnail: '/images/llm-foundations-course.png',
  modules: [
    llmFoundationsModule1,
    llmFoundationsModule2,
    llmFoundationsModule3,
    llmFoundationsModule4,
    llmFoundationsModule5,
    llmFoundationsModule6,
  ],
  tools: {
    reference: true,
    codeRunner: true,
  },
};
